import { defineMessages } from 'react-intl';

export default defineMessages({
  cancelButton: {
    id: 'frontbucket.pipelines.confirmModal.cancelButton',
    description:
      'Default "cancel" button text for pipelines confirm modal component',
    defaultMessage: 'Cancel',
  },
  confirmButton: {
    id: 'frontbucket.pipelines.confirmModal.confirmButton',
    description:
      'Default "confirm" button text for pipelines confirm modal component',
    defaultMessage: 'Confirm',
  },
  pipelineToolbox: {
    id: 'frontbucket.branch.pipelines.actions',
    description: 'Pipeline actions',
    defaultMessage: 'Pipelines',
  },
  actionRunPipeline: {
    id: 'frontbucket.branch.pipelines.run',
    description: 'Run pipelines from a branch view',
    defaultMessage: 'Run Pipeline',
  },
});
